var render = function render(){var _vm=this,_c=_vm._self._c;return _c('block',{attrs:{"title":"月度展会变化情况"}},[_c('el-date-picker',{staticStyle:{"width":"90px"},attrs:{"slot":"actions","size":"mini","clearable":false,"type":"year","value-format":"yyyy"},slot:"actions",model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}}),_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }